<template>
  <div>
    <!-- Explicacion -->
    <!-- Este componente es correspondiente a los botones usados en en todas las tablas y se pueden identificar a travez de un booleano el cual viene 
    dentro de los Props , editar los estilos o iconos de segun el Booleano correspondiente para poder cambiarlo en
    todas las tablas  Suerte ;)  -->

    <template v-if="textButton && textButton !== ''">
      <v-btn
        :color="classColor ? classColor : 'primary'"
        :class="classButton"
        :small="!normalButton"
        :disabled="disabled"
        :dark="!disabled"
        @click="handleClick()"
        :href="href"
        target="_blank"
        :block="blockButton"
        :loading="loading"
        dense
      >
        <v-icon left v-if="iconBut">
          {{ iconBut }}
        </v-icon>
        {{ textButton }}
      </v-btn>
    </template>
    <template v-else>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <!-- :color="[{ 'primary': addButton }, { 'amber lighten-1 ': editButton }, { 'success': verButton }, { 'red': playButton }, { 'primary': cameraButton }, { 'primary': bookButton }, { 'primary': downloadButton }, { 'primary': uploadButton }, { 'black': listButton }, { 'red': deleteButton }, { 'gray': configButton }]" -->
          <v-btn
            :color="
              addButton
                ? 'primary'
                : editButton
                ? 'amber lighten-1'
                : reprogramarButton
                ? 'green'
                : verButton
                ? 'success'
                : playButton
                ? 'red'
                : cameraButton
                ? 'primary'
                : bookButton
                ? 'primary'
                : downloadButton
                ? 'primary'
                : uploadButton
                ? 'primary'
                : listButton
                ? 'black'
                : deleteButton
                ? 'red'
                : configButton
                ? 'grey darken-1'
                : classColor
            "
            v-on="on"
            icon
            :disabled="disabled"
            x-small
            @click="handleClick()"
            :href="href"
            :loading="loading"
            dense
            target="_blank"
            :dark="!disabled"
          >
            <v-icon>
              {{
                addButton
                  ? "fas fa-plus"
                  : editButton
                  ? "fa fa-pencil-alt"
                  : reprogramarButton
                  ? "fas fa-calendar-alt"
                  : verButton
                  ? "fa-eye"
                  : playButton
                  ? "fas fa-play-circle"
                  : cameraButton
                  ? "fas fa-video"
                  : bookButton
                  ? "fas fa-book"
                  : downloadButton
                  ? "fas fa-file-download"
                  : uploadButton
                  ? "fas fa-file-upload"
                  : listButton
                  ? "fa-clipboard-list"
                  : deleteButton
                  ? "fas fa-trash-alt"
                  : configButton
                  ? "fas fa-cogs"
                  : iconBut
              }}
            </v-icon>
          </v-btn>
        </template>
        <span>
          {{ tooltipText }}
        </span>
      </v-tooltip>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    editButton: Boolean,
    classColor: String,
    classButton: String,
    href: String,
    blockButton: Boolean,
    verButton: Boolean,
    downloadButton: Boolean,
    uploadButton: Boolean,
    listButton: Boolean,
    reprogramarButton: Boolean,
    bookButton: Boolean,
    addButton: Boolean,
    cameraButton: Boolean,
    playButton: Boolean,
    disabled: Boolean,
    configButton: Boolean,
    normalButton: Boolean,
    deleteButton: Boolean,
    tooltipText: String,
    textButton: String,
    iconBut: String,
    loading: Boolean,
  },
  data() {
    return {};
  },

  methods: {
    handleClick() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss" scoped>
button.v-btn[disabled] {
  opacity: 1;
}

.btn_block_style2 {
  font-family: "avenir black";
  letter-spacing: 0.42px;
  font-size: 14px;
  color: #fff !important;
}

.btn_block_style2:hover {
  font-family: "avenir black oblique";
  /* background-color: #002f6c !important; */
  background-color: #ffbc00 !important;
  color: #000 !important;
}
</style>
